
import { Flex, Typography } from "antd";

import { Card } from "@hdi-seguros/web-components.card";

import './index.css';

export const CustomTooltip = ({ label = "", hoveredElement }: { label: string, hoveredElement?: any }) => (
    <Card className="custom-tooltip-container">
        <Flex gap={5} align="center" justify="center">
            <Typography.Text strong >
                { label }:
            </Typography.Text>
            <Typography.Text className="custom-tooltip-label-value" > { hoveredElement[0]?.payload?.value } </Typography.Text>
        </Flex>
    </Card>
)

